/// <reference path="../../app.definition.ts" />

function trustText($sce) {
    return function (value: string, type?: string): string {
        return $sce.trustAs(type || 'html', value);
    }
}

angular.module('eCareVault.common.filters').filter('trustText', ['$sce', trustText]);
